import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Web3 from 'web3';
import detectEthereumProvider from '@metamask/detect-provider';
import axios from 'axios';
import '../style/employee.css'; // Import the CSS file
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const contractDOC = require("./EmployeeDocumentManagement.json");
const DOCABI = contractDOC.abi;
const AdvancedEmployeeDocumentManagementADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
const pinataApiKey = process.env.REACT_APP_PINATA_API_KEY; // Replace with your Pinata API Key
const pinataSecretApiKey = process.env.REACT_APP_PINATA_SECRET_KEY; // Replace with your Pinata Secret API Key
const FileUpload = () => {
    const navigate = useNavigate();
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');
    const [loading, setLoading] = useState(false); // Added loading state
    const [formData, setFormData] = useState({
        employeeName: '',
        documentType: '',
        class: '',
        idCardNumber: '',
        email: '',
        mobileNumber: ''
    });
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    const pinFileToIPFS = async (file) => {
        const url = process.env.REACT_APP_PINATA_IPFS_URL;
        const data = new FormData();
        data.append('file', file);
        const metadata = JSON.stringify({
            name: 'testing image only',
            description: "",
            keyvalues: {
                exampleKey: 'exampleValue',
            },
        });
        data.append('pinataMetadata', metadata);
        try {
            const response = await axios.post(url, data, {
                maxBodyLength: 'Infinity',
                headers: {
                    'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
                    pinata_api_key: pinataApiKey,
                    pinata_secret_api_key: pinataSecretApiKey,
                },
            });
            console.log(response);
            return response.data.IpfsHash;
        } catch (error) {
            console.error('Error pinning file to IPFS:', error);
            toast.error('Error pinning file to IPFS.');
            throw error;
        }
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!selectedFile) {
            toast.error('No file selected.');
            return;
        }

        setLoading(true); // Start loading

        try {
            // Pin file to IPFS
            const ipfsHash = await pinFileToIPFS(selectedFile);

            // Detect Ethereum provider
           
            const provider = await detectEthereumProvider();
            const web3 = new Web3(provider);
            const networkId = await web3.eth.net.getId();
            if (Number(networkId) !== 80002) { // 80002 is the network ID for Polygon Mumbai testnet
                toast.error('You are not connected to the correct network. Please switch to the Polygon Amoy testnet.');
                return; // Stop execution if network is incorrect
            }
            if (!provider) {
                toast.error('Please install MetaMask!');
                setLoading(false); // Stop loading
                return;
            }
          
            const accounts = await web3.eth.getAccounts();
            const contract = new web3.eth.Contract(DOCABI, AdvancedEmployeeDocumentManagementADDRESS);

            const info = await contract.methods.getEmployeeInfo(accounts[0]).call();

            try {
                const tx = await contract.methods.addDocument(
                    formData.documentType.toString(),
                    ipfsHash.toString(), // IPFS hash of the file
                    JSON.stringify(formData).toString() ,// Metadata as JSON string,
                    info.idNumber
                ).send({ from: accounts[0] });
                // console.log(tx);

                // Show success toast message
                toast.success('Document submitted successfully!');

                // Redirect to the employee page after a short delay
                setTimeout(() => {
                    navigate('/employee'); // Redirect to the employee page
                }, 3000); // 3000 milliseconds = 3 seconds
            } catch (error) {
                console.error('Error submitting document to contract:', error);
                toast.error('Error submitting document.');
            }
        } catch (error) {
            console.log(error);
            toast.error('Error pinning file to IPFS.');
        } finally {
            setLoading(false); // Stop loading regardless of success or error
        }
    };

    useEffect(() => {
        const checkUserRole = async () => {
            const provider = await detectEthereumProvider();
            if (provider) {
                const web3 = new Web3(provider);
                const contract = new web3.eth.Contract(DOCABI, AdvancedEmployeeDocumentManagementADDRESS);

                try {
                    const accounts = await provider.request({ method: 'eth_requestAccounts' });
                    const walletAddress = accounts[0]; // Get the first account address

                    // Define role constants based on role
                    const role = 'employee'; // This should be dynamically set based on your logic
                    let roleConstant;
                    switch (role) {
                        case 'employee':
                            roleConstant = await contract.methods.EMPLOYEE_ROLE().call();
                            break;
                        case 'admin':
                            roleConstant = await contract.methods.ADMIN_ROLE().call();
                            break;
                        case 'verifier':
                            roleConstant = await contract.methods.APPROVER_ROLE().call();
                            break;
                        case 'owner':
                            // Assume owner role is handled separately
                            roleConstant = null; // No predefined constant for owner
                            break;
                        default:
                            throw new Error("Unknown role");
                    }

                    // If a role constant is defined, check the role
                    if (roleConstant) {
                        const hasRole = await contract.methods.hasRole(roleConstant, walletAddress).call();
                        if (!hasRole) {
                            toast.error("You do not have the required role to access this page.");
                            navigate('/');
                        }
                    } else {
                        // Handle navigation for owner role if needed
                        navigate('/owner');
                    }
                } catch (error) {
                    console.error('Error during role check or navigation:', error);
                    toast.error("Check your role and try again.");
                    navigate('/');
                }
            } else {
                console.error('MetaMask is not installed.');
                toast.error('MetaMask is not installed. Please install MetaMask and try again.');
                navigate('/');
            }
        };

        checkUserRole();
    }, [navigate]);

    return (
        <div className="form-container">
            <h1>File Upload Form</h1>
            {loading && <div className="loader"></div>} {/* Loader */}
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="employeeName">Employee Name:</label>
                    <input
                        type="text"
                        id="employeeName"
                        name="employeeName"
                        value={formData.employeeName}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="documentType">Document Type:</label>
                    <select
                        id="documentType"
                        name="documentType"
                        value={formData.documentType}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Select</option>
                        <option value="PAN">PAN</option>
                        <option value="ADHAR">ADHAR</option>
                        <option value="12th Marksheet">12th Marksheet</option>
                        <option value="10th Marksheet">10th Marksheet</option>
                        {/* Add more options as needed */}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="class">Department:</label>
                    <select
                        id="class"
                        name="class"
                        value={formData.class}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Select</option>
                        <option value="HR">HR</option>
                        <option value="Engineering">Engineering</option>
                        <option value="Sales">Sales</option>
                        <option value="Marketing">Marketing</option>
                        {/* <option value="ME">ME</option> */}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="idCardNumber">ID Card Number:</label>
                    <input
                        type="text"
                        id="idCardNumber"
                        name="idCardNumber"
                        value={formData.idCardNumber}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="mobileNumber">Mobile Number:</label>
                    <input
                        type="text"
                        id="mobileNumber"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="fileUpload">Upload File:</label>
                    <input
                        type="file"
                        id="fileUpload"
                        onChange={(e) => setSelectedFile(e.target.files[0])}
                    />
                </div>
                <button type="submit">Submit</button>
                {uploadStatus && <p>{uploadStatus}</p>}
            </form>
            <ToastContainer />
        </div>
    );
};

export default FileUpload;
